
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCallBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.002 6.839a8.724 8.724 0 0 1 6.16 6.159M18.1 10.204a5.235 5.235 0 0 1 3.696 3.696",
  stroke: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.285 16.078a10.103 10.103 0 0 0 4.678 4.657.95.95 0 0 0 .938-.071l2.998-2a.958.958 0 0 1 .91-.083l5.61 2.404a.955.955 0 0 1 .574.994A5.75 5.75 0 0 1 21.289 27C12.293 27 5 19.707 5 10.71a5.75 5.75 0 0 1 5.021-5.703.955.955 0 0 1 .994.575l2.406 5.614a.958.958 0 0 1-.079.903l-1.992 3.044a.95.95 0 0 0-.065.935z",
  stroke: "#000"
}))));

      const __svgRaw = "<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M19.002 6.839a8.724 8.724 0 0 1 6.16 6.159M18.1 10.204a5.235 5.235 0 0 1 3.696 3.696\" stroke=\"var(--theme-primary, #810ea9)\"/>\r\n        <path d=\"M11.285 16.078a10.103 10.103 0 0 0 4.678 4.657.95.95 0 0 0 .938-.071l2.998-2a.958.958 0 0 1 .91-.083l5.61 2.404a.955.955 0 0 1 .574.994A5.75 5.75 0 0 1 21.289 27C12.293 27 5 19.707 5 10.71a5.75 5.75 0 0 1 5.021-5.703.955.955 0 0 1 .994.575l2.406 5.614a.958.958 0 0 1-.079.903l-1.992 3.044a.95.95 0 0 0-.065.935z\" stroke=\"#000\"/>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/call-black.ac1e2926f78fdd037976802c2c86b267.svg"),
        {
          React: SvgCallBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      